/**
 * Enumeration containing identifiers for different notification types
 *
 * @description
 * This enumeration defines the unique identifiers for each type of notification
 * in the system. These IDs are used to categorize and identify different kinds
 * of notifications that users can receive.
 */
export enum NotificationTypeId {
  /**
   * Coupon notification type
   * @type {number}
   *
   * @description
   * Represents notifications related to coupons, promotions and special offers
   */
  Coupon = 1,

  /**
   * Deposit notification type
   * @type {number}
   *
   * @description
   * Represents notifications about deposit transactions and confirmations
   */
  Deposit = 2,

  /**
   * Withdrawal notification type
   * @type {number}
   *
   * @description
   * Represents notifications about withdrawal requests and processing
   */
  Withdrawal = 3,

  /**
   * KYC notification type
   * @type {number}
   *
   * @description
   * Represents notifications about Know Your Customer verification process
   */
  KYC = 4,

  /**
   * Commission notification type
   * @type {number}
   *
   * @description
   * Represents notifications about commission earnings and payments
   */
  Comission = 5,

  /**
   * Bonus withdrawal notification type
   * @type {number}
   *
   * @description
   * Represents notifications about bonus withdrawal requests and processing
   */
  BonusWithdrawal = 6,

  /**
   * Follow notification type
   * @type {number}
   *
   * @description
   * Represents notifications about new followers or following updates
   */
  Follow = 7,

  /**
   * Bet notification type
   * @type {number}
   *
   * @description
   * Represents notifications about betting activities and results
   */
  Bet = 8,

  /**
   * Tournament notification type
   * @type {number}
   *
   * @description
   * Represents notifications about tournament updates and results
   */
  Tournament = 9,

  /**
   * Reward notification type
   * @type {number}
   *
   * @description
   * Represents notifications about rewards earned or available
   */
  Reward = 10,

  /**
   * Alert notification type
   * @type {number}
   *
   * @description
   * Represents notifications about alerts and warnings
   */
  Alert = 11,
}
